export const FIELD_TYPE_INFO: Record<string, { icon: string; label: string }> =
  {
    text: { icon: "text", label: "Texto" },
    string: { icon: "text", label: "Texto" },
    textarea: { icon: "paragraph", label: "Párrafo" },
    paragraph: { icon: "paragraph", label: "Párrafo" },
    identity: { icon: "id-card", label: "Identidad" },
    passport_number: { icon: "id-card", label: "Pasaporte" },
    passport: { icon: "id-card", label: "Pasaporte" },
    dui_nit: { icon: "id-card", label: "Identidad" },
    select: { icon: "list", label: "Lista" },
    list: { icon: "list", label: "Lista" },
    multiselect: { icon: "list-check", label: "Multi-selección" },
    file: { icon: "file-arrow-up", label: "Archivo" },
    files: { icon: "file-arrow-up", label: "Archivos" },
    switch: { icon: "toggle-on", label: "Sí / No" },
    table: { icon: "table", label: "Tabla" },
    number: { icon: "hashtag", label: "Número" },
    date: { icon: "calendar-clock", label: "Fecha" },
    datetime: { icon: "calendar-clock", label: "Fecha y hora" },
    date_range: { icon: "calendars", label: "Rango de fechas" },
    datetime_range: { icon: "calendars", label: "Rango de fechas y hora" },
    email: { icon: "envelope", label: "Correo" },
    phone: { icon: "phone", label: "Teléfono" },
    external_link: { icon: "link-horizontal", label: "Enlace externo" },
    interoperability: { icon: "diagram-nested", label: "Interoperabilidad" },
    expedient: { icon: "folder-open", label: "Expediente" },
    filtered_select: {
      icon: "filter-list",
      label: "Lista de selección filtrada",
    },
  };
